
<div class="column-pagination d-flex align-items-center">
  <div>
    <span>Page {{ fieldPagination.current_page }} of {{ fieldPagination.total_pages }} |
      Columns {{ startColumn }}-{{ endColumn }} of {{ fieldPagination.total_count }}</span>
  </div>
  <div class="d-flex mx-2" style="gap: 10px;">
    <!-- First Page Button -->
    <v-icon size="26" dense :color="fieldPagination.current_page > 1 ? 'primary' : 'grey'"
      :style="{ cursor: fieldPagination.current_page > 1 ? 'pointer' : 'default' }"
      @click="goToPage(1)">
      mdi-page-first
    </v-icon>

    <!-- Previous Button -->
    <v-icon size="26" dense :color="fieldPagination.current_page > 1 ? 'primary' : 'grey'"
      :style="{ cursor: fieldPagination.current_page > 1 ? 'pointer' : 'default' }"
      @click="goToPage(fieldPagination.current_page - 1)">
      mdi-chevron-left
    </v-icon>

    <!-- Next Button -->
    <v-icon size="26" dense :color="fieldPagination.current_page < fieldPagination.total_pages ? 'primary' : 'grey'"
      :style="{ cursor: fieldPagination.current_page < fieldPagination.total_pages ? 'pointer' : 'default' }"
      @click="goToPage(fieldPagination.current_page + 1)">
      mdi-chevron-right
    </v-icon>

    <!-- Last Page Button -->
    <v-icon size="26" dense :color="fieldPagination.current_page < fieldPagination.total_pages ? 'primary' : 'grey'"
      :style="{ cursor: fieldPagination.current_page < fieldPagination.total_pages ? 'pointer' : 'default' }"
      @click="goToPage(fieldPagination.total_pages)">
      mdi-page-last
    </v-icon>
  </div>
</div>
